import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { useEditingProps, useGetZ3kObject } from '../utils/unpack-props';
import { StrictNumberInput } from 'console/shared/components/fields';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { InputAdornment } from '@mui/material';
import { buzzersGuardIndicatorsOptionsSelector, inputsRadiosensorsOptionsSelector, reactionOptions, } from 'console/device-settings/z3k/components/utils/z3k-selectors';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { SettingContainer } from 'console/device-settings/z3k/components/material-utils/settings-card/container';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { MultipleSelectionTable, } from '../material-utils/multiple-selection-table/multiple-selection';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
export const GuardZoneComponent = memo(function GuardZoneControlImpl() {
    const z3k_name = 'guard_zones';
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { config } = useContext(Z3KSettingsEditor);
    const { device_spec } = useContext(Z3KSettings);
    const inputs_radiosensors_options = inputsRadiosensorsOptionsSelector(config);
    const buzzers_guard_indicators_options = buzzersGuardIndicatorsOptionsSelector(config);
    const notifications_actions_options = reactionOptions(config);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const eventDelayTimeEditingProps = useEditingProps(id, z3k_name, 'event_delay_time');
    const startDelayEditingProps = useEditingProps(id, z3k_name, 'start_delay');
    const event_delay_time_field = useCallback((input_props) => (_jsx(StrictNumberInput, { min: 0, max: 180, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u0441\u0435\u043A" }), ...input_props })), []);
    const start_delay_field = useCallback((input_props) => (_jsx(StrictNumberInput, { min: 0, max: 1000, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u0441\u0435\u043A" }), ...input_props })), []);
    const multipleSelectionSensorsList = useMemo(() => {
        return [
            {
                title: 'Датчики',
                help_id: 'guard_zones_relative_sensor_list',
                options: inputs_radiosensors_options,
                z3k_field: 'relative_sensor_list',
            },
        ];
    }, [item]);
    const multipleSelectionTableOptions = useMemo(() => {
        const result = [
            {
                title: 'Оповещения/действия при срабатывании',
                help_id: 'guard_zones_relative_triggered_list',
                z3k_field: 'relative_triggered_list',
                options: notifications_actions_options,
            },
            {
                title: 'Оповещения/действия при восстановлении',
                help_id: 'guard_zones_relative_recovered_list',
                z3k_field: 'relative_recovered_list',
                options: notifications_actions_options,
            },
            {
                title: 'Оповещения/действия при постановке на охрану',
                help_id: 'guard_zones_relative_turned_on',
                z3k_field: 'relative_turned_on',
                options: notifications_actions_options,
            },
            {
                title: 'Оповещения/действия при снятии с охраны',
                help_id: 'guard_zones_relative_turned_off',
                z3k_field: 'relative_turned_off',
                options: notifications_actions_options,
            },
        ];
        if (device_spec.io.has_buzzers || device_spec.io.has_guard_indicators) {
            result.push({
                title: 'Сирены / индикаторы охраны',
                help_id: 'guard_zones_buzzer_guard_indicator_list',
                z3k_field: 'buzzer_guard_indicator_list',
                options: buzzers_guard_indicators_options,
            });
        }
        return result;
    }, [item]);
    return (_jsx(ErrorBoundary, { children: _jsxs(SettingContainer, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "guard_zones_name", ...nameEditingProps }), _jsx(Control, { label: "\u0417\u0430\u0434\u0435\u0440\u0436\u043A\u0430 \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u043F\u043E\u0441\u043B\u0435 \u0441\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u043D\u0438\u044F", ...eventDelayTimeEditingProps, field: event_delay_time_field, help_id: "guard_zones_event_delay_time" }), _jsx(Control, { label: "\u0417\u0430\u0434\u0435\u0440\u0436\u043A\u0430 \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438 \u043D\u0430 \u043E\u0445\u0440\u0430\u043D\u0443", ...startDelayEditingProps, field: start_delay_field, help_id: "guard_zones_start_delay" }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionSensorsList, z3k_name: z3k_name, notification: false, name_second_column: "\u042D\u043B\u0435\u043C\u0435\u043D\u0442\u044B" }) }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false }) })] }) }));
});
